import { RouterProvider } from "react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { queryClient } from "@/lib/query/queryClient";
import { router } from "./router";
import { ThemeBoot } from "./providers";
import { SessionBoot } from "./SessionBoot";

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeBoot />
      <SessionBoot>
        <RouterProvider router={router} />
      </SessionBoot>
      <Toaster richColors position="top-center" closeButton />
    </QueryClientProvider>
  );
}
